import ReactGA from 'react-ga4';

const expandNodeEvent = (nodeString) => {
    ReactGA.event({
        category: 'Node',
        action: 'Expand',
        label: nodeString
    });
    }

const searchTermEvent = (searchTerm) => {
    ReactGA.event({
        category: 'Search',
        action: 'Search',
        label: searchTerm
    });
    }

const singleClickEvent = (nodeString) => {
    ReactGA.event({
        category: 'Node',
        action: 'Single Click',
        label: nodeString
    });
    }

const loadGraphEvent = (graphName) => {
    ReactGA.event({
        category: 'Graph',
        action: 'Load Graph',
        label: graphName
    });
    }


const events = {
    expandNodeEvent,
    searchTermEvent,
    singleClickEvent,
    loadGraphEvent
}

export default events;